export default function createAssetStr(str: string) {
  const chars = ['.'];

  return str
    .split('')
    .filter((c) => !chars.includes(c))
    .join('')
    .toLowerCase();
}
